'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

var _headerState = require('./headerState');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  bindUIActions();
};

var mobileNavState = function mobileNavState(state) {
  var $mobileNav = $(_dom2.default.mobileNav);
  var $mobileNavTrigger = $(_dom2.default.mobileNavTrigger);
  var $body = $('body');

  if (state === 'active') {
    $mobileNav.addClass('is-active');
    $mobileNavTrigger.find('.icon').removeClass('icon-hamburger-32').addClass('icon-close-32');
    $body.addClass('mobile-nav-active');
  } else {
    $(_dom2.default.mobileNav).removeClass('is-active');
    $(_dom2.default.mobileNavTrigger).find('.icon').removeClass('icon-close-32').addClass('icon-hamburger-32');
    $body.removeClass('mobile-nav-active');
  }
};

var bindUIActions = function bindUIActions() {
  $(_dom2.default.mobileNavTrigger).on('click', function (e) {
    e.preventDefault();

    if (!$(_dom2.default.mobileNav).hasClass('is-active')) {
      mobileNavState('active');
      (0, _headerState.headerState)('active');
    } else {
      mobileNavState('inactive');
      (0, _headerState.headerState)('inactive');
    }
  });

  $(window).on('resize', function () {
    if ($(window).width() >= 1024) {
      mobileNavState('inactive');
    }
  });
};